import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import PropTypes from 'prop-types'
import React from 'react'

import Icon from './icon'

const Summary = ({ children }) => (
  <AccordionSummary expandIcon={<Icon name="chevron-down" size="xs" />}>
    {children}
  </AccordionSummary>
)

Summary.propTypes = {
  children: PropTypes.node.isRequired,
}

Accordion.Summary = Summary
Accordion.Details = AccordionDetails

export default Accordion
